<template>
    <div class="l-body">
        <LBackgruond>
            <template v-slot:mainName> 战报点评 </template>
            <template v-slot:mainContent>
                <div class="l-detail-work-body">
                    <div class="l-logo">
                        <div class="l-type">{{ detailData.battleInfo.userRecord.type }}</div>
                        <img :src="logoUrl" />
                        <div class="l-logo-type">{{ detailData.battleInfo.score }}获得{{ amount }}个LILY币奖励</div>
                    </div>
                    <div class="l-text">
                        <div class="header">
                            <!-- <div class="tiem"> -->
                            <!-- <span>{{ detailData.battleName }}</span> -->
                            <!-- <span>{{ detailData.startTime.slice(0, 10) }}至{{detailData.endTime.slice(0, 10)}}</span> -->
                            <!-- </div> -->
                            <div class="level">
                                {{ detailData.battleInfo.userRecord.stage }}&nbsp;&nbsp;{{
                                    detailData.battleInfo.userRecord.level
                                }}&nbsp;&nbsp;{{ detailData.battleInfo.userRecord.story }}
                            </div>
                        </div>
                        <div v-if="detailData.audioUrl" class="content-box">
                            <div class="content">
                                <div class="title notWell">
                                    <img src="./../images/notWell.png" />
                                    <span>语音点评</span>
                                </div>
                                <div class="text">
                                    <audio class="audio" controls controlsList="nodownload" :src="detailData.audioUrl">
                                        您的浏览器不支持 audio 元素。
                                    </audio>
                                </div>
                            </div>
                            <div class="content">
                                <div class="title notWell">
                                    <span> 上传记录 </span>
                                </div>
                                <div class="text">
                                    <div class="record-list">
                                        <div class="record-item"
                                            v-for="(item, index) in detailData.battleInfo.userRecord.files" :key="index"
                                            @click="handlePreview(item)">
                                            <img v-if="item.type === 'img'" :src="item.url" alt="" />
                                            <video v-else :src="item.url">您的浏览器不支持 video 标签。</video>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="content-box">
                            <div class="content">
                                <div class="title notWell">
                                    <img src="./../images/notWell.png" />
                                    <span>本次战报点评</span>
                                </div>
                                <div class="text">
                                    {{ detailData.battleInfo.notWell }}
                                </div>
                            </div>
                            <div v-if="detailData.battleInfo.plan" class="content plan">
                                <div class="title">
                                    <img src="./../images/plan.png" />
                                    <span> 后续提高方案 </span>
                                </div>
                                <div class="text">{{ detailData.battleInfo.plan }}</div>
                            </div>
                            <div v-if="detailData.battleInfo.plan" class="content">
                                <div class="title well">
                                    <img src="./../images/well.png" />
                                    <span> 本次进步点 </span>
                                </div>
                                <div class="text">{{ detailData.battleInfo.well }}</div>
                            </div>
                            <div class="content">
                                <div class="title notWell">
                                    <span> 上传记录 </span>
                                </div>
                                <div class="text">
                                    <div class="record-list">
                                        <div class="record-item"
                                            v-for="(item, index) in detailData.battleInfo.userRecord.files" :key="index"
                                            @click="handlePreview(item)">
                                            <img v-if="item.type === 'img'" :src="item.url" alt="" />
                                            <video v-else :src="item.url">您的浏览器不支持 video 标签。</video>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </LBackgruond>
        <LGetAward :opsions="awardData"></LGetAward>
        <div v-if="isPreview" class="preview">
            <div class="preview-img">
                <img v-if="preview.type === 'img'" :src="preview.url" alt="" />
                <video v-else :src="preview.url" controls controlslist="nodownload">
                    您的浏览器不支持 video 标签。
                </video>
            </div>
            <div class="preview-colse" @click="isPreview = false">关闭</div>
        </div>
    </div>
</template>
<script>
import LBackgruond from "./../components/l-background";
import LGetAward from "./components/l-get-award/index.vue";
import CourseModel from "./../models/course";
const courseModel = new CourseModel();
export default {
    name: "taskDetail",
    components: {
        LBackgruond,
        LGetAward,
    },
    data () {
        return {
            detailData: {
                startTime: "",
                endTime: "",
                battleInfo: {
                    userRecord: {
                        files: [{ type: "", url: "" }],
                    },
                },
            },
            detailType: [
                {
                    name: "优秀",
                    url: require("./../images/level-excellent.png"),
                },
                {
                    name: "良好",
                    url: require("./../images/level-well.png"),
                },
                {
                    name: "中等",
                    url: require("./../images/level-medium.png"),
                },
                {
                    name: "及格",
                    url: require("./../images/level-pass.png"),
                },
                {
                    name: "未及格",
                    url: require("./../images/level-fail.png"),
                },
            ],
            logoUrl: require("./../images/level-excellent.png"),
            templateList: [],
            amount: 0,
            awardData: {
                amount: 0,
                score: "",
                receiveReward: 1,
                taskId: null,
            },
            isPreview: false,
            preview: {
                type: "",
                url: "",
            },
        };
    },
    mounted () {
        this.detailData = JSON.parse(sessionStorage.getItem("wordDetailData"));
        this.awardData.receiveReward = this.detailData.battleInfo.receiveReward;
        this.awardData.taskId = this.detailData.taskId;

        this.handleSetImg();
        this.handleGetTemplate();
        console.log(this.detailData);
    },
    methods: {
        handleSetImg () {
            if (this.detailData.battleInfo.score) {
                this.awardData.score = this.detailData.battleInfo.score;
                this.detailType.forEach((element) => {
                    if (element.name === this.detailData.battleInfo.score) {
                        this.logoUrl = element.url;
                    }
                });
            }
        },
        handleGetTemplate () {
            courseModel
                .getTemplateValue({
                    name: "战报上传-得分奖励配置",
                })
                .then((res) => {
                    if (res.status === 0) {
                        this.templateList = res.data;
                        this.templateList.forEach((item) => {
                            if (item.data.score === this.detailData.battleInfo.score) {
                                this.amount = item.data.amount;
                                this.awardData.amount = item.data.amount;
                            }
                        });
                    }
                });
        },
        handlePreview (item) {
            this.preview = {};
            this.preview = item;
            this.isPreview = true;
        },
    },
};
</script>
<style lang="stylus" scoped>
@import './css/detail.styl';
</style>
